import { render } from "./VoterList.vue?vue&type=template&id=6cd6194a&scoped=true"
import script from "./VoterList.vue?vue&type=script&lang=ts"
export * from "./VoterList.vue?vue&type=script&lang=ts"

import "./VoterList.vue?vue&type=style&index=0&id=6cd6194a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cd6194a"

export default script